import { Routes } from '@angular/router';
import { UserPermissionGuard } from '@core/guards/user-permission.guard';
import { LoginCallbackComponent } from '@core/navigation/auth/login-callback.component';
import { authenticatedGuard } from '@core/navigation/guards/authenticated.guard';
import { landingGuard } from '@core/navigation/guards/landing.guard';
import { loginRedirectGuard } from '@core/navigation/guards/login-redirect.guard';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'public', pathMatch: 'full' },
  { path: 'callback', component: LoginCallbackComponent, canActivate: [loginRedirectGuard] },
  // Post sign-in decision point (deeplink or User Journey), never rendered
  { path: 'landing', canActivate: [landingGuard], children: [] },
  {
    path: 'public',
    loadChildren: () => import('../modules/public/public.module').then(m => m.PublicModule),
    canActivate: []
  },
  {
    path: 'customer',
    loadChildren: () => import('../modules/customer/customer.module').then(m => m.CustomerModule),
    canActivate: []
  },
  {
    path: '',
    loadChildren: () => import('../modules/protected/protected.module').then(m => m.ProtectedModule),
    canActivate: [authenticatedGuard, UserPermissionGuard]
  },
];
